import React from 'react'
import * as d3 from "../d3.modified.js"

export default class IconNode extends React.PureComponent {
    constructor(props) {
        super(props)
        // this.isJustClickNotDrag = false
        this.props.nodeItem.refs = {}
        this.props.nodeItem._jsx = {
            styleSelect: this.styleSelect,
            styleDeselect: this.styleDeselect,
            styleMove: this.styleMove,
            styleFade: this.styleFade
        }
        this.props.nodeItem.height = 70
    }

    componentDidMount() {
        this.postModifiers()

        var node = this.props.nodeItem

        const _step = 10

        if (node._selectionId!==-1) {
            this.styleSelect()
        }

        node.refs.holder
            .transition()
                .duration(500)
                .style('opacity', 1)

        this.position = undefined;
        node.refs.holder.call(d3.drag()
            .on('start', ()=>{
                this.position = {x:d3.event.x, y:d3.event.y}
                this.props.hideCtxMenus()

                // <grided>
                this.startDragMPosX = d3.event.x
                this.startDragMPosY = d3.event.y
                this.startDragPosX = node.x
                this.startDragPosY = node.y
                // </grided>

                this.props.dragStartHandler()
            })
            .on('drag', ()=>{
                node.refs.holder.classed('moving', true)

                if (node._selectionId === -1) {
                    this.props.clickHandler(node, true)
                }
                if ((!this.props.keyPressDict.link || (this.props.keyPressDict.link && node._selectionId!==-1)) && (!this.props.keyPressDict.ctrl || node._selectionId !== -1)) {
                    // <grided>
                    if (this.props.keyPressDict.grid) {
                        let x = this.startDragPosX + (d3.event.x-this.startDragMPosX)-25//node.width*0.5
                        let y = this.startDragPosY + (d3.event.y-this.startDragMPosY)-25//node.height*0.5
                        x = parseInt((x+_step/2)/_step)*_step
                        y = parseInt((y+_step/2)/_step)*_step

                        let dx = x-node.x+25//node.width*0.5
                        let dy = y-node.y+25//node.height*0.5
                        this.props.dragHandler(dx, dy)
                    } else {
                    // </grided>
                        this.props.dragHandler(d3.event.dx, d3.event.dy)
                    }
                }
            })
            .on('end', ()=>{
                node.refs.holder.classed('moving', false)
                let newPosition = {x:d3.event.x, y:d3.event.y}
                if ((newPosition.x !== this.position.x) || (newPosition.y !== this.position.y) ) {
                    this.props.dragEndHandler()
                }
            })
        )

        node.refs.holder
            .on('mouseenter', ()=>{
                if (this.props.keyPressDict.link) {
                    if (this.props.canCreateLink(node)) {
                        node.refs.holder.classed('linkage-can', true)
                    } else {
                        node.refs.holder.classed('linkage-cannot', true)
                    }
                }
            })
            .on('mouseleave', ()=>{
                if (this.props.keyPressDict.link) {
                    node.refs.holder.classed('linkage-can', false)
                    node.refs.holder.classed('linkage-cannot', false)
                }
            })

        node.refs.holder
            .on("click", ()=>{
                if (this.props.keyPressDict.link) {
                    this.props.createLink(node)
                } else {
                    this.props.clickHandler(node)
                }
                d3.event.stopPropagation()
            })
    }

    postModifiers = () => {
        var node = this.props.nodeItem

        var _ = (a,b,c) => {this.props.enqueueAttrChange({elem:a,attr:b,val:c})}

        if (node.settings.render['title']===false) {
            return
        }

        var hasTitle = (node.properties.title!=='')
        if (hasTitle) {
            var bb = node.refs.title.getBBox()
            node.width = bb.width
            _(node.refs.background, 'width', node.width+10)
            _(node.refs.background, 'x', -node.width/2-5)
        } else {
            node.width = 0
            _(node.refs.background, 'width', node.width)
        }

        // this.props.enqueueStyleChange({
        //     elem: node.refs.background,
        //     prop: 'fill',
        //     val: node.properties.color
        // })
        // this.props.enqueueStyleChange({
        //     elem: node.refs.icon,
        //     prop: 'fill',
        //     val: node.properties.color
        // })
    }

    componentDidUpdate() {
        this.postModifiers()
    }

    styleMove = () => {
        var node = this.props.nodeItem
        this.props.enqueueAttrChange({
            elem: node.refs.holder,
            attr: 'transform',
            val: `translate(${node.x} ${node.y})`
        })
    }

    styleSelect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.icon,
            class: 'active',
            val: true,
        })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: true,
        })
    }

    styleDeselect = () => {
        var node = this.props.nodeItem
        this.props.enqueueClassChange({
            elem: node.refs.icon,
            class: 'active',
            val: false,
        })
        this.props.enqueueClassChange({
            elem: node.refs.background,
            class: 'active',
            val: false,
        })
    }

    styleFade = () => {
        this.props.nodeItem.refs.holder
            .transition()
                .duration(400)
                .style('opacity', 0)
    }

    render() {
        var node = this.props.nodeItem

        const diffColors = {
            none: "#fff",
            yellow: "#FFFFE6",
            green: "#E6FFED",
            red: "#FFEEF0"
        }

        return (
            <g
                className="node-holder node-icon-holder"
                transform={`translate(${node.x} ${node.y})`}
                ref={c=>node.refs.holder=d3.select(c)}
                opacity="0"
            >
            {/* ICON */}
                <circle
                    r="25"
                    cx="0"
                    cy="0"
                    className="node-icon-circle"
                    ref={c=>node.refs.icon=d3.select(c)}
                    id={`N_${node.id}_c`}
                />
                <image
                    x="-25"
                    y="-25"
                    width="50"
                    height="50"
                    clipPath="url(#kruzic)"
                    className="node-icon-circle-img"
                    href={node.properties.path}
                />

                {
                    (node.settings.render['title']!==false)
                        ? [
                            <rect
                                className="node-icon-background"
                                width={node.width+10}
                                height="25"
                                rx="3"
                                ry="3"
                                ref={c=>node.refs.background=d3.select(c)}
                                x={-node.width/2-5}
                                y="30"
                                key="bg"
                                id={`N_${node.id}_bg`}
                                style={{fill: node._compareType?diffColors[node._compareType]:node.properties.color}}
                                // style={{fill: node.properties.color}}
                            />,
                            <text
                                key="title"
                                x="0"
                                y="50"
                                className="node-icon-name"
                                textAnchor="middle"
                                alignmentBaseline="baseline"
                                ref={c=>node.refs.title=c}
                            >{node.properties.title}</text>
                            ]
                        : null
                }
            </g>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/nodes/IconNode.js